<script lang="ts" setup>
// Modal genérico "Crítico": pregunta + 2 botones (cancelar outline-gris / confirmar), sin ícono. Es el componente
// que renderizan `confirm()` y `confirmWithList()` de `@/composables/modalHelper.ts` (no se instancia a mano).
// `destructive: true` pinta el botón de confirmar en rojo — usar SOLO para borrados definitivos (ver ejemplos de
// uso con `destructive` en `RetailMediaAdvertisers.vue`/`RetailMediaCircuits.vue`), para el resto de confirmaciones
// dejar el default violeta.
import PolyButton from '../components/poly/PolyButton.vue'

const props = defineProps<{
  title: string,
  text?: string,
  resolve: (value: boolean) => void,
  hideCancelButton?: boolean,
  list?: string[],
  bottomText?: string,
  cancelText?: string,
  confirmText?: string,
  destructive?: boolean,
}>()
</script>
<template>
  <section class="confirm-modal">
    <span class="title">{{ title }}</span>
    <span v-if="text" class="text">{{ text }}</span>
    <div v-if="list?.length" class="confirm-list">
      <span v-for="item in list" :key="item" class="confirm-list-item">{{ item }}</span>
    </div>
    <span v-if="bottomText" class="text">{{ bottomText }}</span>
    <div class="actions">
      <poly-button v-if="!props.hideCancelButton" button-style="Outline" button-color="Grey" @click.prevent="props.resolve(false)">{{ $t(cancelText || 'CANCELAR') }}</poly-button>
      <poly-button :button-color="destructive ? 'Red' : 'Primary'" @click.prevent="props.resolve(true)">{{ $t(confirmText || 'ACEPTAR') }}</poly-button>
    </div>
  </section>
</template>
<style scoped lang="less">
.confirm-modal {
  background-color: white;
  min-width: 30.769em;
  max-width: 30.769em;
  border-radius: 0.923em;
  padding: 2.462em 1.846em;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.538em;
  text-align: center;

  .title {
    font-size: 1.308em;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.4;
  }

  .text {
    font-size: 1em;
    color: #999;
  }

  .confirm-list {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    background: #ededed;
    border-radius: 0.615em;
    padding: 0.923em 1.231em;
    max-height: 9.231em;
    overflow-y: auto;
    text-align: left;
    gap: 0.308em;
  }

  .confirm-list-item {
    font-size: 1.077em;
    color: #444;
  }

  .actions {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0.77em;
  }
}
</style>
